import { Col, Form, Row } from "react-bootstrap";
import { HeaderRegister } from "../../../components/HeaderRegister";
import { ConfigService } from "../../../services/config.service";
import { ToastService } from "../../../services/toast.service";
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from "react-router-dom";
import { Formik } from "formik";
import { FormDynamicControl } from "../../../components/FormDynamicControl";
import { ColorPicker } from "../../../components/ColorPicker";
import * as yup from 'yup';
import { useEffect, useRef, useState } from "react";
import { ConfigModel, ValueDatatypeList } from "../../../models/config.model";
import _ from "lodash";
import { UtilService } from "../../../services/util.service";
import storageService from "../../../services/storage.service";

export const ConfigRegister = () => {
  const { id } = useParams<{ id?: string }>();
  const [initialValues, setInitialValues] = useState<ConfigModel>({
    id: 0,
    configValue: '',
    key: '',
    valueDatatype: '',
    color: '',
    isRange: false
  });

  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();
  const formRef = useRef();
  const history = useHistory();

  const onSubmit = async (data) => {
    if (Number(id)) {
      await update(data);
    }
  };

  const update = async (data) => {
    try {

      data.id = Number(id);
      const response: any = await ConfigService.update(data);
      if (response.success) {
        ToastService.success(t('CONFIG.UPDATED'))
        history.push(`/Parameter`);
      }
    } catch (error) {
      ToastService.error(t('ERROR_GENERIC'));
    }
  };


  const initialize = async () => {
    if (Number(id)) {
      const response: any = await ConfigService.getById(id);

      try {
        if (response) {
          if (response.result) {
            setInitialValues(response.result);
          }
        }
      } catch (error) {
        ToastService.error(t('ERROR_GENERIC'));
      }
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const schema = yup.object().shape({
    configValue: yup.string().required(t('REQUIRED')),
    key: yup.string().required(t('REQUIRED'))
  });

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  }

  const handleChangeDate = (evt: any, index: number, data: any) => {
    data.configValue = UtilService.formatDate(evt, "yyyy-MM-dd");
  }

  const handleChangeDateTime = (evt: any, index: number, data: any) => {
    data.configValue = UtilService.formatDateTime(evt, "yyyy-MM-dd HH:mm:ss")
  }

  const handleChangeDateRange = (dataInicio: any, dataFim: any, index: number, data: any) => {
    data.configValue = UtilService.formatDate(dataInicio, "yyyy-MM-dd") + "|" + UtilService.formatDate(dataFim, "yyyy-MM-dd");
  }


  const handleChangeMoneyRange = (valorInicio: any, valorFim: any, index: number, data: any) => {
    data.configValue = UtilService.formatNumber(valorInicio) + "|" + UtilService.formatNumber(valorFim);
  }

  const handleChangeMoney = (evt: any, index: number, data: any) => {
    data.configValue = UtilService.formatNumber(evt);
  }

  const handleChangeNumberRange = (valorInicio: any, valorFim: any, index: number, data: any) => {
    data.configValue = UtilService.onlyNumber(valorInicio) + "|" + UtilService.onlyNumber(valorFim);
  }

  const handleChangeNumber = (evt: any, index: number, data: any) => {
    data.configValue = UtilService.onlyNumber(evt);
  }

  const handleChangeColor = (evt: any, index: number, data: any) => {
    data.color = evt.hex;
  }

  const returnDisplay = (valueDatatype: string) => {
    if (valueDatatype == "D" || valueDatatype == "N" || valueDatatype == "I") {
      return "block";
    } else {
      return "none";
    }
  }

  return (
    <>
      <HeaderRegister title={`${t('CONFIG.TITLE')} | ${t('EDITION')}`} path={"/Parameter"} submitForm={submitFormik} />

      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          onSubmit(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          setValues
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} xl={12}>
                <Row>
                  <Col xs={12} sm={6} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='key'
                          id='key'
                          type='text'
                          placeholder={t('CONFIG.KEY')}
                          disabled={true}
                          isInvalid={touched.key && !!errors.key}
                          value={values.key}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.key}
                        </Form.Control.Feedback>
                        <Form.Label>{t('CONFIG.KEY')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='description'
                          id='description'
                          type='text'
                          placeholder={t('CONFIG.DESCRIPTION')}
                          disabled={true}
                          value={t('CONFIG.' + values.key.toUpperCase()).toString()}
                        />
                        <Form.Label>{t('CONFIG.DESCRIPTION')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  {/* <Col xs={6} sm={6} md={6} lg={1}  className="mb-4">
                    <div style={{display: returnDisplay(values.valueDatatype)}}>        
                      <Form.Group>                                   
                        <Form.Check
                        id={`isRange`}
                        name={`isRange`}
                        type='checkbox'                                 
                        checked={values.isRange}
                        onChange={handleChange}                                   
                        />
                        <Form.Label>{t('EQUIPMENT.CONFIG_IS_RANGE')}</Form.Label>                                            
                      </Form.Group>
                    </div>
                  </Col> */}
                  <Col xs={12} sm={6} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <FormDynamicControl
                          id={'configValue'}
                          index={values.id}
                          name={`configValue`}
                          dataType={values.valueDatatype}
                          data={values}
                          disabled={isLoading}
                          value={values.configValue}
                          placeholder={t('CONFIG.VALUE')}
                          onChange={handleChange}
                          handleChangeDate={handleChangeDate}
                          handleChangeDateTime={handleChangeDateTime}
                          handleChangeDateRange={handleChangeDateRange}
                          handleChangeNumber={handleChangeNumber}
                          handleChangeNumberRange={handleChangeNumberRange}
                          handleChangeMoneyRange={handleChangeMoneyRange}
                          handleChangeMoney={handleChangeMoney}
                          type='text'
                          label={t('CONFIG.VALUE')}
                          labelRangeMin={t('FILTER.CONFIG_VALUE_MIN')}
                          labelRangeMax={t('FILTER.CONFIG_VALUE_MAX')}
                          isRange={values.isRange}
                        />
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='valueDatatype'
                          name='valueDatatype'
                          isInvalid={touched.valueDatatype && !!errors.valueDatatype}
                          disabled={true}
                          onChange={handleChange}
                          value={values.valueDatatype}
                          aria-label={t("CONFIG.VALUEDATATYPE")}>
                          <option value="">{t("CONFIG.VALUEDATATYPE")}</option>
                          {_.map(ValueDatatypeList, (i) => {
                            return <option key={i.id} value={i.id}>{t('CONFIG.' + i.name.toUpperCase())}</option>
                          })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.valueDatatype}
                        </Form.Control.Feedback>
                        <label htmlFor="valueDatatype">{t("CONFIG.VALUEDATATYPE")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  {values.color &&
                    <Col xs={12} sm={6} md={6} lg={3} className="mb-4">
                      <Form.Group>
                        <Form.Floating>
                          <ColorPicker
                            color={values.color}
                            handleChangeColor={handleChangeColor}
                            data={values}
                            index={values.id}
                          />
                        </Form.Floating>
                      </Form.Group>
                    </Col>
                  }
                </Row>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
